import styles from "./MinerSection.module.scss";
import cn from "classnames";
import { useState } from "react";
import { IRackSection3, RACK_SECTION_TYPE3 } from "@mobx/store/locations/types";

export interface IMinerSection3Props {
  readonly item: IRackSection3;
  readonly position: [number, number];
  readonly isActive: boolean;

  onClick(): void;
}

const useControl = (props: IMinerSection3Props) => {
  const [outOfRange, _] = useState<boolean>(false);
  return { outOfRange };
};

const MinerSection3 = (props: IMinerSection3Props) => {
  const control = useControl(props);
  return (
    <div
      className={cn(styles.miner, {
        [styles.active]: props.isActive,
        [styles.miner_position]:
          props.item.pos === RACK_SECTION_TYPE3.MINER && !control.outOfRange,
        [styles.miner_outOfRange]: control.outOfRange,
      })}
      onClick={props.onClick}
    />
  );
}

export default MinerSection3;